import React from "react";

// Lightweight CSS spinner: this is the Suspense fallback of the whole app, so it must not pull
// heavy libraries (the previous Lottie animation put ~80kB gzip into the main bundle).
const Loading = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
      role="status"
      aria-label="در حال بارگذاری"
    >
      <div
        className="spinner-border"
        style={{ width: "3rem", height: "3rem", color: "#35c075" }}
      ></div>
    </div>
  );
};

export default Loading;
